import React, { useState, useEffect } from 'react';
import { persistor } from '../../createStore';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ScriptTag from 'react-script-tag';
import {
  Button,
  InputText,
  CPFInput,
  PhoneInput,
  NascimentoInput,
  ValidateCPF,
  ValidatePhone,
  ValidateName,
  ValidateEmail,
  ValidateBirthdayUnderage,
  Checkbox,
} from 'veloe-ds';
import { withSnackbar } from 'notistack';
import {
  salvarDadosUsuario,
  salvarListaProdutos,
  salvarTipoVeiculo,
  totalProdutos,
  salvarPedido,
  salvarCodigoPromocional,
} from '../../actions/pedidoActions';

import { converterOndeUsarData } from '../../utils/codigoPromocional';
import { getData } from '../../api/dataAPI';
import { APP_PAGES } from '../../routes';

import './register.scss';
import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import dadosPessoaisFCG from '../../mutations/dadosPessoais';
import consultarCodigoPromocionalParceriasFCG from '../../queries/consultarCodigoPromocionalParcerias';
import consultarCodigoPromocionalPadroesFCG from '../../queries/consultarCodigoPromocionalPadroes';
import {
  modalCadastroExistente,
  modalInformativo,
} from '../../Components/Modais';
import {
  uuidVwo,
  accountVwo,
  campaignDataVwo,
  campaignDetailsVwo,
} from '../../utils/vwo';
import { getParams } from '../../utils/getUrlParameter.js';

import { eventTrackBasic, eventTrackRoute } from '../../utils/pushDataLayer.js';
import { useFetchExperimento } from '../../hooks/useFetchExperimento';

const Index = ({
  pedido,
  salvarDadosUsuario,
  salvarListaProdutos,
  salvarTipoVeiculo,
  totalProdutos,
  activeLoader,
  inactiveLoader,
  salvarCodigoPromocional,
  ...props
}) => {
  useFetchExperimento()
  
  const registerButton = {
    status: false,
    label: 'Informe os dados para continuar',
  };
  const proposta = JSON.parse(localStorage.getItem('proposta'));
  if (proposta === null) {
    localStorage.setItem('propostaFinalizada', false);
    pedido.dadosCartao = {};
    pedido.dadosCartao.numero = '';
    pedido.dadosCartao.CVV = '';
    pedido.dadosCartao.melhorDiaCobranca = '';
    pedido.dadosCartao.validade = '';
    pedido.dadosCartao.nome = '';
    pedido.debitoEmConta = {};
    pedido.debitoEmConta.instituicao = '';
    pedido.debitoEmConta.digitoConta = '';
    pedido.debitoEmConta.agencia = '';
    pedido.debitoEmConta.melhorDiaCobranca = '';
    pedido.debitoEmConta.conta = '';
    pedido.tipoPagamento = '';
    pedido.dadosEndereco = {};
    pedido.dadosVeiculo = {
      placa: "",
      confirmPlaca: "",
      categoriaVeiculo: "CARRO",
      categoriaEixo: ""
    };
    pedido.ondeReceber = {};
    pedido.receberAdesivo = {};
    pedido.dadosUsuario = {};
    pedido.codigoPromocional = {};
    salvarPedido(pedido);
  }

  const [userDataState] = useState({
    celular: '',
    cpf: '',
    dataNascimento: '',
    email: '',
    nomeCompleto: '',
  });
  const [token, setToken] = useState('');
  const [emailDataModal, setEmailDataModal] = useState(false);
  const [cpfDataModal, setCpfDataModal] = useState(false);
  const [checkBoxSelected, setCheckBoxSelected] = useState(false);
  const [registerButtonState, setRegisterButtonState] =
    useState(registerButton);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorServiceModal, setErrorServiceModal] = useState(false);
  const [campaignData, setCampaignData] = useState({});
  const [vwo, setVwo] = useState({
    uuid: '',
    ex: '',
    acc: '',
    cbt: '',
    go: '',
  });
  const [codigoPromocional, setCodigoPromocional] = useState({
    codigoValido: false,
    codigo: {
      origem: '',
      name: '',
    },
    planosCodigo: [],
    planosDefault: [],
  });

  useEffect(() => {
    persistor.purge();
    localStorage.clear();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setCodigoPromocional((prevState) => {
        return {
          ...prevState,
          codigo: { name: getParams('codigo'), origem: getParams('origem') },
        };
      });
    }, 1000);
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/auth/token`, {
      method: 'POST',
    })
      .then((response) => response.json())
      .then(({ access_token }) => {
        setToken(access_token);
        localStorage.setItem('token', access_token);
      })
      .catch((error) => console.log('error', error));
  }, []);

  useEffect(() => {
    setTimeout(async () => {
      await veloeGraphQlApi(consultarCodigoPromocionalPadroesFCG, {}, token)
        .then((data) => {
          const results = data.consultarCodigoPromocionalPadroes || [];
          setCodigoPromocional((prevState) => {
            return {
              ...prevState,
              planosDefault: results,
              planos: {
                todos: converterOndeUsarData(results).todos,
                opcoes: converterOndeUsarData(results).opcoes,
              },
            };
          });
        })
        .catch(({ message }) => {
          console.log(message);
        });
    }, 1200);
  }, [token]);

  useEffect(() => {
    setTimeout(async () => {
      await veloeGraphQlApi(
        consultarCodigoPromocionalParceriasFCG,
        {
          cod: codigoPromocional.codigo.name,
        },
        token,
      )
        .then((data) => {
          const results = data.consultarCodigoPromocionalParcerias || [];
          if (
            codigoPromocional.codigo.origem === 'LP' &&
            !results.length <= 0
          ) {
            const CODIGO_PROMOCIONAL_VALIDO = true;
            setCodigoPromocional((prevState) => {
              return {
                ...prevState,
                planosCodigo: results,
                codigoValido: CODIGO_PROMOCIONAL_VALIDO,
                planos: {
                  todos: converterOndeUsarData(
                    results,
                    CODIGO_PROMOCIONAL_VALIDO,
                  ).todos,
                  opcoes: converterOndeUsarData(
                    results,
                    CODIGO_PROMOCIONAL_VALIDO,
                  ).opcoes,
                },
              };
            });
          }
        })
        .catch(({ message }) => {
          console.log(message);
        });
    }, 1500);
  }, [codigoPromocional.codigo.name, codigoPromocional.codigo.origem, token]);

  useEffect(() => {
    setTimeout(() => {
      setCampaignData(campaignDataVwo());
    }, 1500);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setVwo((...prevState) => {
        return {
          ...prevState,
          uuid: uuidVwo() || '',
          acc: accountVwo() || '',
          ex: campaignDetailsVwo(campaignData).campaignId || '',
          cbt: campaignDetailsVwo(campaignData).typeId || '',
        };
      });
    }, 1800);
  }, [campaignData]);

  useEffect(() => {
    eventTrackRoute('cadastro');
  }, []);

  useEffect(() => {
    if (userDataState.cpf === '') {
      localStorage.clear();
    }
    validatesUserData(userDataState);
  }, [userDataState]);

  const changeForm = (event, key) => {
    userDataState[key] = event;
    validatesUserData(userDataState);
  };

  const changeCheckBox = () => {
    if (!checkBoxSelected) {
      setCheckBoxSelected(true);
    } else {
      setCheckBoxSelected(false);
    }
  };

  const callFuncRand = async () => {
    const isLocal = process.env.NODE_ENV === 'development';
    const reCaptcha = isLocal
      ? 'local-development'
      : await window.grecaptcha.execute(process.env.REACT_APP_KEY_RECAPTCHA, {
          action: 'homepage',
        });

    activeLoader();
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    let idProposta;
    if (proposta != null) {
      idProposta = proposta.dados.id;
    }
    eventTrackBasic('clique:botao', 'continuar-cadastro');
    const VWO = () => {
      const { uuid, acc, ex, cbt, go } = vwo;
      if (cbt !== '' && ex !== '') {
        return { uuid, acc, ex, cbt, go };
      }
      return;
    };
    const { origem: dataOrigem } = codigoPromocional.codigo;

    await veloeGraphQlApi(dadosPessoaisFCG, {
      id: idProposta,
      nome: userDataState.nomeCompleto,
      cpf: userDataState.cpf.replace(/[^\d]/g, ''),
      dataNascimento: userDataState.dataNascimento,
      telefoneCelular: userDataState.celular.replace(/[^\d]/g, ''),
      email: userDataState.email,
      recebimentoInformacoesEmail: checkBoxSelected,
      captchaResponse: reCaptcha,
      fluxoCanal: 'FLUXO WEB Novo',
      origem: dataOrigem || '',
      ...VWO(),
    })
      .then((data) => {
        const { dados, validatorResponse } = data['dadosPessoaisFCG'];
        if (dados) {
          const tipoAutomoveis = getData('tipoAutomoveis');
          localStorage.setItem(
            'proposta',
            JSON.stringify(data['dadosPessoaisFCG'] || {}),
          );
          inactiveLoader();
          salvarDadosUsuario(userDataState);
          salvarCodigoPromocional(codigoPromocional);
          salvarTipoVeiculo('automoveis');
          tipoAutomoveis[0].checkBox = true;
          salvarListaProdutos([tipoAutomoveis[0]]);
          const total = {
            valorTotalProdutos: 0,
            qtdTotalProdutos: '1',
            nomeQtdProdutos: '1 Adesivo',
          };
          totalProdutos(total);
          eventTrackBasic('callback:cadastro', 'sucesso', {
            id: dados.id,
            cpf: userDataState.cpf,
          });
          props.history.push(APP_PAGES.RECEBER_PRODUTO);
        } else {
          const { errors } = validatorResponse;
          inactiveLoader();
          return errors.map((error) => {
            eventTrackBasic('callback:cadastro', error.message);
            const message = error.message.toLowerCase();
            setErrorMessage(error.message);
            if (message.includes('cpf')) {
              setCpfDataModal(true);
            } else if (message.includes('e-mail')) {
              setEmailDataModal(true);
            }
          });
        }
      })
      .catch((err) => {
        inactiveLoader();
        eventTrackBasic('callback:cadastro', err.message);
        setErrorMessage(err.message);
        setErrorServiceModal(true);
      });
  };

  const validatesUserData = (userDataState) => {
    const formularioValido =
      ValidateCPF.isValid(userDataState.cpf) &&
      ValidateEmail.isValid(userDataState.email) &&
      ValidateBirthdayUnderage.isValid(userDataState.dataNascimento) &&
      ValidateName.isValid(userDataState.nomeCompleto) &&
      ValidatePhone.isValid(userDataState.celular);

    if (formularioValido) {
      setRegisterButtonState({ status: false, label: 'Continuar' });
    } else {
      setRegisterButtonState({
        status: true,
        label: 'Informe os dados para continuar',
      });
    }
  };

  return (
    <div className="containerComponent">
      <div className="containerText">
        <div className="containerLabel">
          <span className="areaTexto">Para começar, preencha alguns dados</span>
        </div>
      </div>
      <div className="containerArea">
        <div className="containerCadastro">
          <InputText
            {...ValidateName}
            id="nome-completo"
            label="Nome completo"
            onChange={(event) => changeForm(event, 'nomeCompleto')}
            onFocus={() => eventTrackBasic('interacao:campo', 'nome-completo')}
            value={userDataState.nomeCompleto}
          />

          <CPFInput
            {...ValidateCPF}
            label="CPF"
            id="cpf"
            onChange={(event) => changeForm(event, 'cpf')}
            onFocus={() => eventTrackBasic('interacao:campo', 'cpf')}
            value={userDataState.cpf}
          />

          <NascimentoInput
            {...ValidateBirthdayUnderage}
            label="Data de nascimento"
            id="data-nascimento"
            onChange={(event) => changeForm(event, 'dataNascimento')}
            onFocus={() =>
              eventTrackBasic('interacao:campo', 'data-nascimento')
            }
            value={userDataState.dataNascimento}
          />

          <InputText
            {...ValidateEmail}
            label="E-mail"
            id="email"
            onChange={(event) => changeForm(event, 'email')}
            onFocus={() => eventTrackBasic('interacao:campo', 'email')}
            value={userDataState.email}
          />

          <PhoneInput
            {...ValidatePhone}
            label="DDD + Celular"
            id="celular"
            onChange={(event) => changeForm(event, 'celular')}
            onFocus={() => eventTrackBasic('interacao:campo', 'celular')}
            value={userDataState.celular}
          />

          <div style={{ display: 'flex' }}>
            <Checkbox
              {...{ checked: checkBoxSelected }}
              onClick={changeCheckBox}
              onBg="light"
              id="checkbox-termos"
            />
            <span className="labelCheckBox">
              Desejo receber mensagens sobre promoções, descontos e benefícios
              por SMS, e-mail ou WhatsApp
            </span>
          </div>

          <Button
            {...{
              onBg: 'light',
              id: 'btn-continuar',
              color: 'primary',
              disabled: registerButtonState.status,
              label: registerButtonState.label,
            }}
            onClick={callFuncRand}
          />
          {cpfDataModal &&
            modalCadastroExistente(
              true,
              () => {
                setCpfDataModal(false);
              },
              'modalCPFJaExistente',
              errorMessage,
            )}
          {emailDataModal &&
            modalCadastroExistente(
              true,
              () => {
                setEmailDataModal(false);
              },
              'modalEmailJaExistente',
              errorMessage,
            )}
          {errorServiceModal &&
            modalInformativo(
              true,
              () => {
                setErrorServiceModal(false);
              },
              'Ops!',
              errorMessage,
            )}
        </div>
      </div>
      <ScriptTag
        type="text/javascript"
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
      />
    </div>
  );
};

const mapStateToProps = ({ app, pedido }) => {
  return { app, pedido };
};

const mapDispatchToProps = (dispatch) => {
  return {
    salvarCodigoPromocional: (codigoPromocional) =>
      dispatch(salvarCodigoPromocional(codigoPromocional)),
    salvarDadosUsuario: (dadosUsuario) =>
      dispatch(salvarDadosUsuario(dadosUsuario)),
    salvarPedido: (pedido) => dispatch(salvarPedido(pedido)),
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
    salvarTipoVeiculo: (idVeiculo) => dispatch(salvarTipoVeiculo(idVeiculo)),
    salvarListaProdutos: (listaDeProdutos) =>
      dispatch(salvarListaProdutos(listaDeProdutos)),
    totalProdutos: (infoTotal) => dispatch(totalProdutos(infoTotal)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(Index));

Index.propTypes = {
  pedido: PropTypes.shape({
    dadosUsuario: PropTypes.object,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
